import React, { useState, useEffect } from 'react'
import SecondHeader from '../components/SecondHeader/SecondHeader'
import Footer from '../components/Footer/Footer'
import SampleBanner from '../components/sampleComponents/sampleBanner/SampleBanner'
import { useDispatch, useSelector } from 'react-redux'
import { ResetPasswordAPI } from '../redux/slices/ResetPassword'
import { useNavigate } from 'react-router-dom'
import { useFormik } from 'formik'
import { resetPasswordSchema } from '../schemas/resetPasswordSchema'

const ResetPassword = () => {

    const dispatch = useDispatch()
    const loading = useSelector(state => state.ResetPasswordSlice.loading)
    const navigate = useNavigate()

    const [formData, setFormData] = useState({
        password: '',
        confirm_password: '',
        email: localStorage.getItem("forgotEmailAddress"),
        otp: localStorage.getItem("otp")
    });

    const [visibility, setVisibility] = useState({
        passwordVisible: false,
        confirmPasswordVisible: false,
    });

    // const handleInputChange = (e) => {
    //     const { name, value } = e.target;
    //     setFormData({ ...formData, [name]: value });
    // };

    const togglePasswordVisibility = () => {
        setVisibility((prevState) => ({
            ...prevState,
            passwordVisible: !prevState.passwordVisible,
        }));
    };

    const toggleConfirmPasswordVisibility = () => {
        setVisibility((prevState) => ({
            ...prevState,
            confirmPasswordVisible: !prevState.confirmPasswordVisible,
        }));
    };

    const handleResetSubmit = async (values) => {
        // Get email and otp from localStorage
        const email = localStorage.getItem("forgotEmailAddress");
        const otp = localStorage.getItem("otp");
        const resetPasswordData = {
            email,
            otp,
            password: values.password,
            confirm_password: values.confirm_password
        };
        const res = await dispatch(ResetPasswordAPI(resetPasswordData));
        if (res?.payload?.status === 200) {
            navigate("/signin");
        }
    };


    const formik = useFormik({
        initialValues: {
            password: "",
            confirm_password: "",
        },
        validationSchema: resetPasswordSchema,
        onSubmit: (values) => {
            handleResetSubmit(values)
        }
    });

    return (
        <>
            <SecondHeader />
            <SampleBanner />
            <div className="signup-form pt-5 pb-5">
                <div className="container">
                    <div className="row justify-content-center mb-4">
                        <div className="col-xl-4 col-lg-4 col-md-8">
                            <h1 className="main-form-heading">Add New Password</h1>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-xl-4 col-lg-4 col-md-8">
                            <form className="needs-validation" onSubmit={formik.handleSubmit}>
                                <div className="mb-3 custom-input-box">
                                    <input
                                        type={visibility.passwordVisible ? 'text' : 'password'}
                                        className="form-control pass-input"
                                        name="password"
                                        placeholder="Enter New Password"
                                        value={formik.values.password}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    <i
                                        className={`fa-solid ${visibility.passwordVisible ? 'fa-eye-slash' : 'fa-eye'}`}
                                        onClick={togglePasswordVisibility}
                                        style={{ cursor: 'pointer' }}
                                    ></i>
                                    {formik.errors.password && formik.touched.password && <p className="danger-text">{formik.errors.password}</p>}
                                </div>

                                <div className="mb-3 custom-input-box">
                                    <input
                                        type={visibility.confirmPasswordVisible ? 'text' : 'password'}
                                        className="form-control pass-input"
                                        name="confirm_password"
                                        placeholder="Confirm Your Password"
                                        value={formik.values.confirm_password}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    <i
                                        className={`fa-solid ${visibility.confirmPasswordVisible ? 'fa-eye-slash' : 'fa-eye'}`}
                                        onClick={toggleConfirmPasswordVisibility}
                                        style={{ cursor: 'pointer' }}
                                    ></i>

                                    {formik.errors.confirm_password && formik.touched.confirm_password && <p className="danger-text">{formik.errors.confirm_password}</p>}
                                </div>

                                <div className="submit-btn-form">
                                    <button type="submit" disabled={loading} className="btn btn-primary w-50">
                                        {!loading ? 'Reset Your Password' : <i style={{ fontSize: '22px' }} className="fa-solid fa-spinner fa-spin"></i>}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default ResetPassword